import { createStyles, makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import { StepperPageContext } from '../../../context';
import BaseTypography from '../../Text/BaseTypography';
import { StepNavigationActions } from './StepNavigationActions';
import { StepperProgress } from './StepperProgress';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '-webkit-fill-available',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  }),
);
export const StepperPageHeader: React.FC = () => {
  const classes = useStyles();
  const { pageTitle } = useContext(StepperPageContext);
  return (
    <div className={classes.root}>
      <BaseTypography data-testid="stepper-page-title" fontType="13Medium">
        {pageTitle}
      </BaseTypography>
      <StepperProgress />
      <StepNavigationActions />
    </div>
  );
};
